export default __webpack_public_path__ + "static/media/Drawing.cf473191.png";